<template>
  <section class="traffic-source__modal">
    <Modal v-model:show="active">
      <template v-slot:header>
        <h5 class="modal-title">
          {{ $t('trafficSources.addTrafficSources.title') }}
        </h5>
      </template>

      <form @keyup.enter="send">
        <UiInput
          v-model="form.name"
          v-model:error="errors.name"
          class="mb-12"
          :label="$t('trafficSources.addTrafficSources.name')"
          :placeholder="$t('trafficSources.addTrafficSources.trafficSourceName')"
          error-clear-on-change
        />
        <UiInput
          v-model="form.external_id"
          v-model:error="errors.external_id"
          class="mb-12"
          :label="$t('trafficSources.addTrafficSources.externalId')"
          :placeholder="$t('trafficSources.addTrafficSources.externalId')"
          error-clear-on-change
        />
        <div class="row row-wrap__subid">
          <div
            v-for="(item, i) in form.subids"
            :key="i"
            class=" mb-12 col-6 col-6__add-subid"
          >
            <UiInputSubid
              v-model="item.value"
              :label="`SubID ${form.subids.indexOf(item) + 1}`"
              :placeholder="$t('trafficSources.postbacks.notSpecified')"
              :can-delete="form.subids.indexOf(item) === form.subids.length - 1 && form.subids.length > 1"
              @delete="popSubIds"
            />
          </div>
          <div class="col-6 !tw-flex !tw-items-end col-6__add-subid">
            <button
              :disabled="form.subids.length >= 5"
              href="#"
              class="btn btn-block btn-outline-primary btn-sm mb-12"
              @click.prevent="form.subids.length < 5 && addSubId()"
            >
              + {{ $t('promoCodes.addPromocodes.addAnotherSubid') }}
            </button>
          </div>
        </div>
      </form>

      <template v-slot:footer>
        <div class="!tw-text-right">
          <a
            class="btn btn-outline-primary btn-sm mt-8 mb-4"
            @click="close"
          >{{ $t('trafficSources.addTrafficSources.cancel') }}</a>
          <a
            class="btn btn-primary btn-sm ml-16 mt-8 mb-4"
            @click="send"
          >{{ $t('trafficSources.addTrafficSources.send') }}</a>
        </div>
      </template>
    </Modal>
  </section>
</template>

<script>
import { Modal } from '@/components';

export default {
  components: {
    Modal,
  },
  props: ['offsetParams'],
  emits: ['addTrafficSource'],
  data() {
    return {
      active: false,
      form: {
        name: '',
        external_id: '',
        subids: [{ value: '' }],
      },
      errors: {},
    };
  },

  methods: {
    open(id) {
      this.reset();
      this.active = true;
    },
    close() {
      this.active = false;
      this.reset();
    },
    send() {
      const data = {
        name: this.form.name,
        external_id: this.form.external_id,
      };
      let i = 1;
      this.form.subids.forEach((e) => {
        data[`subid${i}`] = e.value;
        i++;
      });
      this.$store.dispatch('createTrafficSource', data)
        .then(() => {
          this.$emit('addTrafficSource');
          this.$store.dispatch('getTrafficSourcesLazy', { ...this.offsetParams });
          this.$alert.success(this.$t('trafficSources.addTrafficSources.wasCreated'));
          this.close();
        }).catch((err) => {
          this.errors = err.response.data.errors;
        });
    },
    reset() {
      this.errors = {};
      this.form.name = '';
      this.form.external_id = '';
      this.form.subids = [
        {
          value: '',
        },
      ];
    },
    addSubId() {
      this.form.subids.push({
        value: '',
      });
    },
    popSubIds(item) {
      this.form.subids.pop();
    },
  },
};
</script>

<style lang="scss">
.traffic-source__modal {
  textarea {
    border: 1px solid #d9d9d9;
    border-radius: 8px;
    min-height: 115px !important;
  }

  .btn-outline-primary {
    min-width: 100px !important;
  }

  .btn-primary {
  }
}
</style>
